import { RegisterForm } from "@/features/user/forms/register-form";
import { useLng } from "@/hooks/use-lng";
import { appTitleHead } from "@/lib/app-document-title";
import { useTranslation } from "@/lib/i18n/client";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/registermember")({
  head: () => appTitleHead("create-account"),
  component: RegisterMemberPage
});

function RegisterMemberPage() {
  const lng = useLng();
  const { t } = useTranslation(lng, "translation");

  return (
    <div className="block w-full max-w-full pt-0 md:flex md:items-start md:justify-center">
      <div className="container mx-auto px-4 py-4 md:py-8">
        <h1 className="hidden text-left md:block">{t("create-account")}</h1>
        <p className="mb-5 whitespace-pre-line">{t("create-account-first-description")}</p>
        <h2 className="text-base font-bold">{t("create-account-second-title")}</h2>
        <p>{t("create-account-second-description")}</p>
        <RegisterForm />
      </div>
    </div>
  );
}
